import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const AdventsCalendar = lazy(
  () =>
    import('./AdventsCalendar.eager').then(mod => ({
      default: mod.AdventsCalendar,
    })),
  {
    fallback: <LoadingPageSpinner />,
  },
);
